import { atom } from 'jotai';

import type { LeadType } from 'Components/Pdp/LeadCTAs/LeadCTAs.entity';

export const leadFormIdAtom = atom<LeadType | ''>('');
